import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import 'antd/dist/antd.min.css';

import Router from "./router";
import i18n from "./translation";
import { useEffect } from "react";
import './index.css'; // Tailwind styles

const rtlLanguages = ['ar', 'he', 'fa', 'ur'];

const isRTL = (lang: string) => rtlLanguages.includes(lang);

const App = () => {

  const { i18n: GG } = useTranslation();


  useEffect(() => {
    const dir = isRTL(i18n.language) ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  return (
    //@ts-ignore
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
